import { useAdSlot } from '../useAds';
import type { AdSlotContext } from '../ads.types';
import AdHeroCarousel from './AdHeroCarousel';
import { AdBillboard, AdBillboardSkeleton } from './AdBillboard';

interface AdSlotProps {
  id: string;
  context?: AdSlotContext;
  autoPlayInterval?: number;
  variant?: 'default' | 'compact';
  onDismiss?: () => void;
  showDismiss?: boolean;
  className?: string;
}

function AdSlot({
  id,
  context,
  autoPlayInterval = 5000,
  variant = 'default',
  className,
}: AdSlotProps) {
  const { data, isLoading, error, layoutType } = useAdSlot(id, context);

  if (isLoading) {
    let SkeletonComponent;
    if (layoutType === 'hero' || layoutType === 'carousel') {
      // Hero has its own built in skeleton but we can return null to let it handle itself if slotName is passed
      return null; 
    } else {
      SkeletonComponent = AdBillboardSkeleton;
    }
    return (
      <div className={className}>
        <SkeletonComponent variant={variant} />
      </div>
    );
  }

  if (error || !data || data.items.length === 0) {
    return null;
  }

  const renderContent = () => {
    switch (layoutType) {
      case 'hero':
      case 'carousel':
        return <AdHeroCarousel slotName={id} autoPlayInterval={autoPlayInterval} />;
      case 'billboard':
      case 'sidebar':
      default:
        return <AdBillboard data={data} variant={variant} />;
    }
  };

  return <div className={className}>{renderContent()}</div>;
}

export default AdSlot;
